import { ApiPath } from "enums";
import { Get } from "utils";

export const getDepots = async ({ ...query }) => {
  const res = await Get(`${ApiPath.GetDepots}`, query);
  return res.data;
};
